import type MenuI from '@/types/Navigation/MenuI'
import type MenuItemI from '@/types/Navigation/MenuItemI'
import { useAppStore } from '@/stores'
import fetchGql from '@/utils/fetchGql'
import { useCacheStorage } from '@/composables/useSessionStorage'
import { isEn } from '@/utils/helpers'

const { getCache } = useCacheStorage()

const query = gql`
  query MenuItems($language: String) {
    MenuItems(starts_with: $language, resolve_links: "url", by_slugs: "corporate/shared/company-header-menu") {
      items {
        content {
          items
        }
      }
    }
  }
`

const getMenuData = (item: MenuItemI, locale: string) => {
  let target = '_self'

  const itemUrl = item.redirect?.story?.full_slug ?? item.redirect?.url
  if (item.redirect?.target) {
    target = item.redirect.target
  }

  const dataLayerData = {
    title: item.redirect?.story?.name || item.dataLayerTitle || '',
    slug: item.redirect?.story?.slug || item.dataLayerSlug || ''
  }

  const data = {
    title: item.title,
    key: formatSbPath(itemUrl, locale) || '/',
    target,
    enData: {
      name: dataLayerData.title,
      slug: dataLayerData.slug
    }
  }

  return data
}

const parseData = (data: any, locale: string) => {
  const result: MenuI[] = []

  data[0].content.items.forEach((menuItem: MenuItemI) => {
    result.push({
      ...getMenuData(menuItem, locale)
    })
  })

  return result
}

export const useFetchHeaderMenu = () => {
  const appStore = useAppStore()
  const fetchHeaderMenu = async (language: string) => {
    const cache = await getCache(`header-nav-${language}`)

    const variables = {
      language: isEn(language) ? '' : `${language}/*`
    }

    if (cache.value.data) {
      appStore.loading = false
      return cache.value.data
    }

    return fetchGql(query, variables).then(async (response: any) => {
      return (cache.value.data = parseData(response.MenuItems.items, variables.language))
    })
  }

  return { fetchHeaderMenu }
}
